
import { mapActions } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  beforeMount() {
    this.channels = [
      this.$constants.Channels.ZOMATO,
      this.$constants.Channels.SWIGGY
    ];
  },
  data() {
    return {
      valid: false,
      channels: [],
      menuHandoverUrl: "",
      menuHandoverCopyFrom: "zomato",
      dishPhotosUrl: "",
      dishPhotosCopyFrom: "zomato",
      loading: false,
      urlRule: [
        (v) =>
          (!!v && v.trim() !== "" && this.isURL(v)) ||
          "Valid channel URL is required"
      ]
    };
  },
  methods: {
    ...mapActions("menu", ["menuGetAssistance"]),

    handleMenuUploadingDataSubmission() {
      this.loading = true;
      let payload = {
        menu_handover: {
          copy_from:
            this.menuHandoverCopyFrom === "url"
              ? ""
              : this.menuHandoverCopyFrom,
          url: this.menuHandoverCopyFrom === "url" ? this.menuHandoverUrl : ""
        },
        dish_photos: {
          copy_from:
            this.dishPhotosCopyFrom === "url" ? "" : this.dishPhotosCopyFrom,
          url: this.dishPhotosCopyFrom === "url" ? this.dishPhotosUrl : ""
        }
      };
      this.menuGetAssistance(payload)
        .then((response) => {
          if (response.status === 200) {
            this.$emit("show-uploading-request-send-dialog");
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
